<template>
  <div class="w-full">
    <div
      v-for="(tab, index) in steps"
      :key="`vertical-${tab.step}`"
      class="hidden md:flex flex-col items-stretch justify-start"
    >
      <div class="flex items-center justify-start gap-3">
        <div class="leftContentWidth" :class="step == tab.step ? 'text-blueG0 font-bold' : 'stepColor'">
          {{ $t(`verificationStatus.regisetrProgress.step${index + 1}`) }}
        </div>
        <div :class="step == tab.step ? 'bg-blueG0' : 'progressBgColor'" class="w-2 h-2 rounded-full" />
        <div
          :class="step == tab.step ? 'text-blueG0 font-bold' : 'stepColor'"
          class="flex-1 text-sm titleContent"
        >
          {{ $t(tab.title) }}
        </div>
      </div>
      <div v-if="index < steps.length - 1" class="flex items-center justify-start gap-3">
        <div class="leftContentWidth"  />
        <div class="flex-none w-1 h-8 border-r border-r-dashed border-r-blackG4 opacity-40" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegisterStepperGeneral',
  props: {
    step: { type: Number, required: true },
    // Array<RegisterFormTab>
    steps: { type: Array, default: [] }
  }
};
</script>
<style lang="scss" scoped>
.leftContentWidth {
  width: 75px;
  text-align: right;
}
.progressBgColor {
  background-color: #dedede;
}
.stepColor {
  color: #dedede;
}
.titleContent {
  max-width: 200px;
}
</style>
